import View from './Create';
import enhancer from './Create.enhancer';

export default enhancer(View);
